import React from "react";
import styles from "./SubscribeBannerText.module.scss";

const SubscribeBannerText = () => {
  return (
    <div className={styles.textContainer}>
      <p className={styles.mainText}>
        Subscribe to NG.ai News for real-time AI insights, personalized updates,
        and expert analysis—delivered straight to your inbox.
      </p>
    </div>
  );
};

export default SubscribeBannerText;
